import {Component, OnInit, Output, EventEmitter, Input, ViewChild} from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../services/user.service';
import { WorkSpaceService } from '../../services/work-space.service';
import { UserModel } from '../../models/user.model';
import { environment } from '../../../../../environments/environment';
import { ResponsiveMode } from '../../models/responsive-mode.type';
import { SassHelperComponent } from '../../providers/sass-helper/sass-helper.component';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';

@Component({
  selector: 'morva-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent implements OnInit {

  @Output() titleEmit = new EventEmitter();
  @Output() routeChange = new EventEmitter<string>();
  @Output() userLogout = new EventEmitter();
  user: UserModel;
  title: string;
  activeWorkspaceId: string;
  avatarPath: string;

  responsiveMode: ResponsiveMode;
  private sassHelper: SassHelperComponent;

  constructor(
    private router: Router,
    private userService: UserService,
    private workspaceService: WorkSpaceService,
    private breakPointObserver: BreakpointObserver,
  ) {
    this.sassHelper = new SassHelperComponent();
  }

  ngOnInit(): void {
    this.getUser();
    this.setSubscribers();
  }

  getUser() {
    this.userService.loadUserMinInfo();
  }

  navigateToProfilePage(): void {
    this.title = 'مدیریت حساب کاربری';
    this.titleEmit.emit(this.title);
    this.routeChange.emit(`/home/profile/${this.activeWorkspaceId}/${this.user.id}`);
  }

  logOutUser(): void {
    this.userLogout.emit();
  }

  setSubscribers() {
    this.workspaceService.getActiveWorkSpaceID().subscribe(
      (activeWorkspaceId) => {
        this.activeWorkspaceId = activeWorkspaceId;
      },
    );
    this.userService.getUserMinState().subscribe((userMinInfo: UserModel) => {
      this.user = userMinInfo;
      if (userMinInfo !== null) {
        this.avatarPath = `${environment.api}/File/Download?path=${userMinInfo.avatarPath}`;
      }
    });
    this.breakPointObserver.observe([this.sassHelper.smMaxWidth,
    this.sassHelper.mdMaxWidth]).subscribe(
      (state: BreakpointState) => {
        if (state.breakpoints[this.sassHelper.smMaxWidth]) {
          this.responsiveMode = 'sm';
        } else if (state.breakpoints[this.sassHelper.mdMaxWidth]) {
          this.responsiveMode = 'md';
        } else {
          this.responsiveMode = 'xl';
        }
      });
  }
}
